import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { connect, useDispatch } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import * as auth from "../_redux/authRedux";
import { login } from "../_redux/authCrud";
import "./index.css";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import Swal from "sweetalert2";
import { useHistory } from "react-router";
//import { showSuccessDialog, showErrorDialog } from "../../../utility";
import { browserName } from "react-device-detect";

import Button from "react-bootstrap/Badge";
import { env } from "../../../../env";

const axios = require("axios").default;

/*
  INTL (i18n) docs:
  https://github.com/formatjs/react-intl/blob/master/docs/Components.md#formattedmessage
*/

/*
  Formik+YUP:
  https://jaredpalmer.com/formik/docs/tutorial#getfieldprops
*/

const initialValues = {
  username: "",
  password: "",
  requestVerificationToken: "",

};

function Login(props) {
  const { intl } = props;
  const history = useHistory();
  const dispatch = useDispatch();
  const valueRef = useRef(null);
  const [loading, setLoading] = useState(false);
  const [captchaCode, setCaptchaCode] = useState("");
  const [captchaVal, setCaptchaVal] = useState("");

  const browser = browserName;
  console.log(browser, "browser");

  useEffect(() => {
    generateCaptcha();
  }, []);

  const LoginSchema = Yup.object().shape({
    username: Yup.string().required(
      intl.formatMessage({
        id: "AUTH.VALIDATION.REQUIRED_FIELD",
      })
    ),
    password: Yup.string().required(
      intl.formatMessage({
        id: "AUTH.VALIDATION.REQUIRED_FIELD",
      })
    ),
  });

  const enableLoading = () => {
    setLoading(true);
  };

  const disableLoading = () => {
    setLoading(false);
  };

  const getInputClasses = (fieldname) => {
    if (formik.touched[fieldname] && formik.errors[fieldname]) {
      return "is-invalid";
    }

    if (formik.touched[fieldname] && !formik.errors[fieldname]) {
      return "is-valid";
    }

    return "";
  };

  const formik = useFormik({
    initialValues,
    validationSchema: LoginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      enableLoading();

      // const input = valueRef.current.value;
      // console.log(input, "input");

      if (captcha === captchaVal) {
        setTimeout(() => {
          login(values.username, values.password)
            .then((response) => {
              if (response.data.status === 401) {
                Swal.fire({
                  title: "Error!",
                  text: `${response.data.message}`,
                  icon: "error",
                  heightAuto: false,
                  confirmButtonText: "Ok",
                });
                setCaptchaVal("");
                generateCaptcha();
              } else {
                console.log("sukses");
              }
              disableLoading();
              const token = response.data.data.token;
              props.login(token);
            })
            .catch((response) => {
              console.log(response);
              setStatus(
                intl.formatMessage({
                  id: "AUTH.VALIDATION.INVALID_LOGIN",
                })
              );
            })
            .finally(() => {
              disableLoading();
              setSubmitting(false);
            });
        }, 1000);
      } else {
        Swal.fire({
          title: "Error!",
          text: `The Captcha is invalid`,
          icon: "error",
          heightAuto: false,
          confirmButtonText: "Ok",
        });
        setCaptchaVal("");
        generateCaptcha();
        disableLoading();
        setSubmitting(false);
      }
    },
  });

  const [inputtext, setinputtext] = useState({
    email: "",
    password: "",
  });

  const [warnemail, setwarnemail] = useState(false);
  const [warnpassword, setwarnpassword] = useState(false);

  const [eye, seteye] = useState(true);
  const [password, setpassword] = useState("password");
  const [type, settype] = useState(false);

  const inputEvent = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setinputtext((lastValue) => {
      return {
        ...lastValue,
        [name]: value,
      };
    });
  };

  const Eye = () => {
    if (password == "password") {
      setpassword("text");
      seteye(false);
      settype(true);
    } else {
      setpassword("password");
      seteye(true);
      settype(false);
    }
  };

  const [captcha, setCaptcha] = useState("");

  const generateCaptcha = () => {
    const randomCaptcha = generateRandomString(6); // Ganti angka 6 dengan panjang CAPTCHA yang diinginkan
    setCaptcha(randomCaptcha);
  };

  function generateRandomString(length) {
    const characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    const cryptoArray = new Uint8Array(length);
    window.crypto.getRandomValues(cryptoArray);

    for (let i = 0; i < length; i++) {
      const randomIndex = cryptoArray[i] % characters.length;
      result += characters.charAt(randomIndex);
    }
    return result;
  }

  const [tokenCsfr, setTokenCsfr] = useState("");

  const getCSRFToken = async () => {
    const response = await axios.get(
      `${env.REACT_APP_API_URL}/api/AntiForgeryToken`
    );

    axios.defaults.headers.post["__RequestVerificationToken"] =
      response.data.data;
    axios.defaults.headers.post["X-CSRF-TOKEN"] = response.data.data;
    document
      .getElementsByTagName("meta")
      .namedItem("csrf-token")
      .setAttribute("content", response.data.data);
    initialValues.requestVerificationToken = response.data.data;
  };

  console.log(tokenCsfr, "response");

  useEffect(() => {
    // getCSRFToken();
  }, []);

  return (
    <div className="login-form login-signin" id="kt_login_signin_form">
      {/* begin::Head */}
      <div className="text-center mb-10 mb-lg-20">
        <div
          className="login-aside d-flex flex-row-auto bgi-size-cover bgi-no-repeat p-10 p-lg-10 mb-10"
          style={{
            backgroundImage: `url(${toAbsoluteUrl("/media/logos/Logo.png")})`,
            width: 377,
            height: 68,
          }}
        ></div>
      </div>
      {/* end::Head */}

      {/*begin::Form*/}
      <form onSubmit={formik.handleSubmit} className="form-group mt-10">
        <div className="form form-group fv-plugins-icon-container">
          <input
            type="hidden"
            name="__RequestVerificationToken"
            value={`${initialValues.requestVerificationToken}`}
            {...formik.getFieldProps("requestVerificationToken")}
          />
          <div className="form-group fv-plugins-icon-container">
            <label
              className="font-weight-normal"
              style={{
                color: "#404040",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontSize: "16px",
                lineHeight: "19px",
              }}
            >
              Username
            </label>
            <div className="input-text input-login ">
              <input
                type="text"
                className={`form-control input-login ${getInputClasses(
                  "username"
                )}`}
                placeholder="Username"
                name="Username"
                {...formik.getFieldProps("username")}
              />
              <i className="fa fa-user"></i>
            </div>
            {formik.touched.username && formik.errors.username ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.username}</div>
              </div>
            ) : null}
          </div>
        </div>

        <div className="form form-group fv-plugins-icon-container">
          <div className="form-group fv-plugins-icon-container">
            <label
              className="font-weight-normal"
              style={{
                color: "#404040",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontSize: "16px",
                lineHeight: "19px",
              }}
            >
              Password
            </label>
            <div className="input-text input-login">
              <input
                type={password}
                className={` ${warnpassword ? "warning" : ""} ${
                  type ? "type_password" : ""
                }`}
                placeholder="Password"
                name="password"
                {...formik.getFieldProps("password")}
              />
              <i className="fa fa-lock"></i>
              <i
                onClick={Eye}
                className={`fa ${eye ? "fa-eye-slash" : "fa-eye"}`}
              ></i>
            </div>
            {formik.touched.password && formik.errors.password ? (
              <div className="fv-plugins-message-container">
                <div className="fv-help-block">{formik.errors.password}</div>
              </div>
            ) : null}
          </div>
        </div>

        <div className="form form-group fv-plugins-icon-container">
          <div className="form-group fv-plugins-icon-container">
            <label
              className="font-weight-normal"
              style={{
                color: "#404040",
                fontFamily: "Poppins",
                fontStyle: "normal",
                fontSize: "16px",
                lineHeight: "19px",
              }}
            >
              Captcha
            </label>

            {process.env.NODE_ENV !== "development" && (
              <div
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/bg/captcha-bg.png"
                  )})`,
                  userSelect: "none",
                  MozUserSelect: "none",
                  WebkitUserSelect: "none",
                  msUserSelect: "none",
                }}
              >
                <p className="captcha justifu-align-center">{captcha}</p>
              </div>
            )}

            {process.env.NODE_ENV === "development" && (
              <div
                style={{
                  backgroundImage: `url(${toAbsoluteUrl(
                    "/media/bg/captcha-bg.png"
                  )})`,
                }}
              >
                <p className="captcha justifu-align-center">{captcha}</p>
              </div>
            )}

            <div class="inputWithIcon">
              <input
                placeholder="Enter the Captcha"
                type="text"
                className={`form-control input-login `}
                id="captcha"
                name="captcha"
                onChange={(e) => {
                  setCaptchaVal(e.target.value);
                }}
                autoComplete="off"
                value={captchaVal}
              />
            </div>
          </div>
        </div>

        <div className="form-group d-flex flex-wrap justify-content-center align-items-center">
          <button
            id="kt_login_signin_submit"
            type="submit"
            disabled={formik.isSubmitting}
            className={`btn btn-primary text-btn form-control mt-5`}
          >
            <span>Login</span>
            {loading && <span className="ml-3 spinner spinner-black"></span>}
          </button>
        </div>
      </form>
      {/*end::Form*/}
    </div>
  );
}

export default injectIntl(connect(null, auth.actions)(Login));
